define('models/pages/wishlist/offers/page',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var WishOfferPage = Model.extend({
        defaults: {
        },
        constructor: function() {
            Model.apply(this, arguments);
        },
        parse: function(data){
            return data;
        },
        dispose: function() {
            if (this.disposed) { return; }
            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return WishOfferPage;
});
